import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Case, Default } from 'react-if';

import DownIcon from '@nerdwallet/react-icon/material/ArrowDownward';
import UpIcon from '@nerdwallet/react-icon/material/ArrowUpward';
import { Box } from '@nerdwallet/currency/components/Box';
import { colors } from '@nerdwallet/base-styles/generated/variables';

export const SENTIMENTS = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
  NEUTRAL: 'neutral',
};

export const DIRECTIONS = {
  UP: 'UP',
  DOWN: 'DOWN',
};

const sentimentColors = {
  [SENTIMENTS.POSITIVE]: colors['green-light'],
  [SENTIMENTS.NEGATIVE]: colors['red-lighter'],
};

const ArrowIndicator = ({
  className,
  directionOverride,
  sentiment,
  marginRight,
}) => {
  // If the sentiment is neutral, we do not need to render an arrow.
  if (sentiment === SENTIMENTS.NEUTRAL) return null;

  // Unless an override is provided, we will assume that positive sentiment renders an up arrow,
  // and negative sentiment renders a down arrow.
  const direction =
    directionOverride ??
    (sentiment === SENTIMENTS.POSITIVE ? DIRECTIONS.UP : DIRECTIONS.DOWN);

  return (
    <Box className={className} marginRight={marginRight}>
      <Switch>
        <Case condition={direction === DIRECTIONS.UP}>
          <UpIcon color={sentimentColors[sentiment]} textAligned />
        </Case>
        <Default>
          <DownIcon color={sentimentColors[sentiment]} textAligned />
        </Default>
      </Switch>
    </Box>
  );
};

ArrowIndicator.propTypes = {
  className: PropTypes.string,
  directionOverride: PropTypes.oneOf(Object.values(DIRECTIONS)),
  sentiment: PropTypes.oneOf(Object.values(SENTIMENTS)).isRequired,
  marginRight: PropTypes.number,
};

ArrowIndicator.defaultProps = {
  marginRight: 2,
};

export default ArrowIndicator;
